import React, { useState, useEffect, useRef } from "react";
import { FaPlus, FaFileAlt, FaEdit, FaTrash } from "react-icons/fa";
import DashboardHeader from "./DashboardHeader";
import PostCard from "./PostCard";

const Dashboardlayout = () => {
  const [posts, setPosts] = useState([]);
  const [activeTab, setActiveTab] = useState("Active");
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentPostId, setCurrentPostId] = useState(null);
  const [newPost, setNewPost] = useState({
    title: "",
    content: "",
    description: "",
    category: "Misc", // Default category to avoid undefined
    status: "Active",
    imageFile: null,
    videoFile: null,
});

  const [categories] = useState([
    "Product",
    "Banner",
    "Collection",
    "Hero",
    "Features",
    "Customer Support",
    "Social proof",
    "Marquee",
    "CountDown Section",
    "Slider Sections",
    "On Scroll Section",
    "Faqs.",
    "Tabs Section",
    "Image Gallery",
    "Misc",
    "Social media",
    "Blog",
  ]); // Predefined categories
  const [isLoading, setIsLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const modalRef = useRef();

  useEffect(() => {
    fetchPosts();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowModal(false);
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal]);

  const fetchPosts = async () => {
    try {
      const response = await fetch("https://xebrand.in/Backend/get_data.php");
      const data = await response.json();
      console.log("Fetched Data:", data);

      if (data.success) {
        setPosts(data.data);
      } else {
        console.error("Error fetching posts:", data.message);
      }
    } catch (error) {
      console.error("Error in fetchPosts:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPost((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setNewPost((prev) => ({ ...prev, [name]: files[0] }));
  };

  const openModal = (post = null) => {
    if (post) {
        setCurrentPostId(post.id);
        setNewPost({
            title: post.name || "",
            content: post.content || "",
            description: post.description || "",
            category: post.category || "Misc", // Set category to a default if not provided
            status: post.status || "Active",
            imageFile: null,
            videoFile: null,
            existingImagePath: post.image_path || "",
            existingVideoPath: post.video_path || "",
        });
        setEditMode(true);
    } else {
        setCurrentPostId(null);
        setNewPost({
            title: "",
            content: "",
            description: "",
            category: "Misc", // Default category
            status: "Active",
            imageFile: null,
            videoFile: null,
            existingImagePath: "",
            existingVideoPath: "",
        });
        setEditMode(false);
    }
    setShowModal(true);
};


  const handleSavePost = async () => {
    setIsLoading(true);

    const formData = new FormData();
    if (editMode) formData.append("id", currentPostId);
    formData.append("name", newPost.title);
    formData.append("content", newPost.content);
    formData.append("description", newPost.description); // Add description
    formData.append("category", newPost.category); // Add category
    formData.append("status", newPost.status);

    if (newPost.imageFile) {
      formData.append("imageFile", newPost.imageFile);
    } else if (editMode && newPost.existingImagePath) {
      formData.append("existingImagePath", newPost.existingImagePath);
    }

    if (newPost.videoFile) {
      formData.append("videoFile", newPost.videoFile);
    } else if (editMode && newPost.existingVideoPath) {
      formData.append("existingVideoPath", newPost.existingVideoPath);
    }

    try {
      const response = await fetch(
        editMode
          ? "https://xebrand.in/Backend/edit_post.php"
          : "https://xebrand.in/Backend/save_data.php",
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await response.json();
      setIsLoading(false);

      if (data.success) {
        setStatusMessage(editMode ? "Post updated successfully!" : "Post added successfully!");
        fetchPosts();
        setShowModal(false);
      } else {
        console.error("Error:", data.message);
        alert(data.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error saving post:", error);
    }
  };

  const handleDeletePost = async (id) => {
    if (window.confirm("Are you sure you want to delete this post?")) {
      try {
        const response = await fetch(
          `https://xebrand.in/Backend/delete_post.php?id=${id}`,
          {
            method: "GET",
          }
        );
        const data = await response.json();
        if (data.success) {
          setStatusMessage("Post deleted successfully!");
          setPosts((prev) => prev.filter((post) => post.id !== id));
        } else {
          console.error("Error deleting post:", data.message);
          alert("Error: " + data.message);
        }
      } catch (error) {
        console.error("Error deleting post:", error);
      }
    }
  };

  return (
    <div className="main-universal-cont flex-1 p-6">
      <DashboardHeader />
      {statusMessage && (
        <div className="p-2 mb-4 text-sm text-green-700 bg-green-100 rounded">
          {statusMessage}
        </div>
      )}

      <div className="flex items-center justify-between pt-4 pb-4">
        <h2 className="text-2xl font-bold text-gray-800">Dashboard</h2>
        <button
          onClick={() => openModal()}
          className="flex items-center gap-2 bg-indigo-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
        >
          <FaPlus />
          Add Post
        </button>
      </div>

      <div className="border-b flex items-center">
        <button
          onClick={() => setActiveTab("Active")}
          className={`flex items-center gap-2 px-4 py-2 text-sm font-medium ${
            activeTab === "Active"
              ? "text-blue-500 border-b-2 border-blue-500"
              : "text-gray-500"
          }`}
        >
          <FaFileAlt />
          Active
        </button>
        <button
          onClick={() => setActiveTab("Draft")}
          className={`flex items-center gap-2 px-4 py-2 text-sm font-medium ${
            activeTab === "Draft"
              ? "text-blue-500 border-b-2 border-blue-500"
              : "text-gray-500"
          }`}
        >
          <FaFileAlt />
          Draft
        </button>
      </div>

      <div className="py-6 grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-6">
        {posts.length === 0 ? (
          <div className="text-center text-gray-500 text-sm">No posts available.</div>
        ) : (
          posts
            .filter((post) => post.status === activeTab)
            .map((post) => (
              <div key={post.id} className="relative">
                <PostCard
                  name={post.name}
                  content={post.content}
                  description={post.description} // Pass description
                  image_path={post.image_path}
                  video_path={post.video_path}
                  status={post.status}
                  user_name={post.user_name}
                  profile_picture={post.profile_picture}
                />
                <div className="absolute top-2 right-2 flex gap-2">
                  <button
                    onClick={() => openModal(post)}
                    className="text-blue-500 hover:text-blue-700"
                  >
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => handleDeletePost(post.id)}
                    className="text-red-500 hover:text-red-700"
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
            ))
        )}
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div ref={modalRef} className="bg-white p-6 rounded-lg w-1/3">
            <h3 className="text-lg font-bold mb-4">
              {editMode ? "Edit Post" : "Add New Post"}
            </h3>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Title</label>
              <input
                type="text"
                name="title"
                value={newPost.title}
                onChange={handleInputChange}
                className="w-full border rounded px-3 py-2 mt-1"
                placeholder="Enter title"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Content</label>
              <textarea
                name="content"
                value={newPost.content}
                onChange={handleInputChange}
                className="w-full border rounded px-3 py-2 mt-1"
                placeholder="Enter content here..."
                rows={5}
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Description</label>
              <textarea
                name="description"
                value={newPost.description} // Bind to description field
                onChange={handleInputChange}
                className="w-full border rounded px-3 py-2 mt-1"
                placeholder="Enter a short description here..."
                rows={3}
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Status</label>
              <select
                name="status"
                value={newPost.status}
                onChange={handleInputChange}
                className="w-full border rounded px-3 py-2 mt-1"
              >
                <option value="Active">Active</option>
                <option value="Draft">Draft</option>
              </select>
            </div>
               {/* Category Dropdown */}
               <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Category</label>
              <select
                name="category"
                value={newPost.category}
                onChange={handleInputChange}
                className="w-full border rounded px-3 py-2 mt-1"
              >
                <option value="" disabled>
                  Select a category
                </option>
                {categories.map((category) => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Image File</label>
              <input
                type="file"
                name="imageFile"
                accept="image/*"
                onChange={handleFileChange}
                className="w-full border rounded px-3 py-2 mt-1"
              />
              {!newPost.imageFile && newPost.existingImagePath && (
                <img
                  src={newPost.existingImagePath}
                  alt="Existing Image"
                  className="mt-2 w-full h-32 object-cover rounded"
                />
              )}
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Video File</label>
              <input
                type="file"
                name="videoFile"
                accept="video/*"
                onChange={handleFileChange}
                className="w-full border rounded px-3 py-2 mt-1"
              />
              {!newPost.videoFile && newPost.existingVideoPath && (
                <video
                  controls
                  src={newPost.existingVideoPath}
                  className="mt-2 w-full h-32 object-cover rounded"
                />
              )}
            </div>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleSavePost}
                className={`px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 ${
                  isLoading ? "cursor-not-allowed opacity-50" : ""
                }`}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : editMode ? "Update Post" : "Add Post"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboardlayout;
